require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./public-perceptions-of-use-of-force.json") })
        }
      }, "path---public-perceptions-of-use-of-force");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---public-perceptions-of-use-of-force!./.cache/json/public-perceptions-of-use-of-force.json
// module id = 962
// module chunks = 231608221292675